function formatCurrency(
  balance,
  { currency, currencySymbol } = {},
  settings = {
    locale: 'he-IL',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }
) {
  if (currency) {
    if (currency === 'UZS') {
      settings.minimumFractionDigits = 0;
      settings.maximumFractionDigits = 0;
    }

    const formatter = new Intl.NumberFormat('he-IL', {
      style: 'currency',
      currency: currency,
      currencyDisplay: 'symbol',
      minimumFractionDigits: settings.minimumFractionDigits,
      maximumFractionDigits: settings.maximumFractionDigits,
    });

    let formattedBalance = formatter.format(balance);
    const parts = formattedBalance.split(/[0-9]/);
    const standardSymbol = parts[parts.length - 1].trim();
    const customSymbol = currencySymbol;
    formattedBalance = formattedBalance.replace(standardSymbol, customSymbol);
    return formattedBalance;
  }
}

function getCurrencySymbol(currencyCode) {
  return new Intl.NumberFormat('he-IL', {
    style: 'currency',
    currency: currencyCode,
  })
    .formatToParts(1)
    .find((part) => part.type === 'currency').value;
}

export { formatCurrency, getCurrencySymbol };
